<script>
  export let centerDesc = ['중앙 설명'];
</script>

<div class="center-desc-wrapper">
  <div class="center-desc-main">{centerDesc.at(0)}</div>
  {#if centerDesc.at(1)}
    <div class="center-desc-sub">{centerDesc.at(1)}</div>
  {/if}
  {#if centerDesc.at(2)}
    <div class="center-desc-sub">{centerDesc.at(2)}</div>
  {/if}
</div>

<style>
  .center-desc-wrapper {
    width: 100%;
    margin: 0 auto;
  }
  .center-desc-main {
    font-weight: 400;
    font-size: 30px;
    text-align: center;
  }
  .center-desc-sub {
    font-weight: 200;
    font-size: 20px;
    text-align: center;
  }
  @media screen and (max-width: 768px) {
    .center-desc-sub {
      font-size: 5vw;
    }
  }
</style>
